import { useSelector, useDispatch } from "react-redux";
import style from "./style.module.scss";
import { CSSProperties, FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { studioActions } from "../../../store/studio";
import { fotActions } from "../../../store/fot";
import { editorActions } from "../../../store/editor";
import func from "@uikit/func";
import useObjectRelationGqlRequest from "../../../custom-hooks/useObjectRelationGqlRequest";
import { PROJECT_LOAD_SIZE } from "../constants";
import { debounce, findIndex, isNil, uniqBy } from "lodash";
import useWaitingTodo from "../../../custom-hooks/useWaitingTodo";
import { useNavigate } from "react-router-dom";
import { logEvent } from "@uikit/service/amplitude";
import cls from "classnames";
import { Help } from "../../components/Help";
import { useModal } from "../../../uiview/views/AModal/useModal";
import Project from "./Project";
import Function from "./Function";
import ApiProgress from "./ApiProgress";
import Template from "./Template";
import PreviewExplorer from "./Preview/PreviewExplorer";
import PreviewQuickStart from "@views/thinking-layout-editor/Home/Preview/PreviewQuickStart";
import Carousel from "./Carousel";
import Sidebar from "./Sidebar";
import { SidebarItems } from "./Sidebar/types";
import { Contents, VideoModalState } from "./types";
import { ApiStatuses, FunctionModel, ProjectModel, QuickStartModel, TemplateModel, TutorialModel } from "../types";
import { ProjectDropdownItemArgs, ProjectDropdownItems } from "./Project/type";
import { FunctionDropdownItemArgs, FunctionDropdownItems } from "./Function/type";
import { VideoModal } from "./VideoModal";
import { AppDispatch } from "@store/index";
import { getIt } from "@uikit/getIt";
import { FotClient } from "imagica-corekit/dist/base/api/FotClient";
import { useProjectTemplate } from "./useProjectTemplate";
import InfiniteScroll from "react-infinite-scroll-component";
import { animated, useSpring } from "@react-spring/web";
import { PersonalFunctionStore } from "imagica-corekit/dist/base/store/PersonalFunctionStore";
import { notification } from "antd";
import { ArgsProps } from "antd/lib/notification";
import { HomeUsePluginUtil } from "@uikit/util/HomeUsePluginUtil";
import useFeatureTags from "@custom-hooks/useFeatureTags";
import { useHomeUsePluginContainer } from "@custom-hooks/HomeUsePluginRoot";
import { delay, getAssetsVideo } from "@views/thinking-layout-editor/utilities";
import { useSignal } from "@preact/signals-react";
import Loader from "./Loader";
import { usePreviewAppStore } from "@custom-hooks/HomeUsePluginRoot/usePreviewAppStore";
import { HomeStore } from "imagica-corekit/dist/cases/store/HomeStore";
import { useStore } from "imagica-uikit/dist/hooks/useStore";
import { WebConfigStore } from "imagica-corekit/dist/cases/webconfig/WebConfigStore";

const notify = (args: ArgsProps) => {
  notification.open({
    ...args,
    className: cls(style.notify, args.className),
  });
};

export interface HomeProps {
  node: any;
  userFunctionsLoading: any;
  showDisableStudiosOnboarding: any;

  setShowMyModification: Function;
  setMyModificationData: Function;
  setShowNavPage: Function;
  loadFromExistingTemplateV2: Function;
  handleUserSavedFunctions: Function;
  pushFunc: Function;
  emptyNodes: Function;
  clickZoomFitIcon: Function;
  initNewProjectV2: Function;
  getSimpleNodeData: Function;
  clickStep: Function;
  addNewProject: Function;
  setShowCot: Function;
  newEdgeDataRef: any;
  newLineDataRef: any;
}

const Home: FC<HomeProps> = ({
  node,
  userFunctionsLoading,
  showDisableStudiosOnboarding,

  setShowMyModification,
  setMyModificationData,
  setShowNavPage,
  loadFromExistingTemplateV2,
  handleUserSavedFunctions,
  pushFunc,
  emptyNodes,
  clickZoomFitIcon,
  initNewProjectV2,
  getSimpleNodeData,
  clickStep,
  addNewProject,
  setShowCot,
  newEdgeDataRef,
  newLineDataRef,
  ...props
}) => {
  const homeStore: any = getIt(HomeStore);
  ///////////// NEW
  const feature_tags = useFeatureTags();
  const { nodeIndexRef, edgeIndexRef } = useHomeUsePluginContainer();
  const dispatch = useDispatch<AppDispatch>();
  const { clearPreviewApp } = usePreviewAppStore();
  const navigate = useNavigate();
  const userMe = useSelector((state: any) => state.editor.me);
  const [page, setPage] = useState(1);
  const [sidebarItem, setSidebarItem] = useState<SidebarItems>(SidebarItems.Templates);
  const [content, setContent] = useState<Contents>(Contents.Templates);
  const [videoModalState, setVideoModalState] = useState<VideoModalState>({
    isOpen: false,
    videoUrl: "",
    videoName: "",
  });
  const [myTutorials, setMyTutorials] = useState<TutorialModel[]>([]);
  const [myTemplates, setMyTemplates] = useState<TemplateModel[]>([]);
  const [myProjects, setMyProjects] = useState<ProjectModel[]>([]);
  const [myFunctions, setMyFunctions] = useState<FunctionModel[]>([]);
  const [loadingOfTemplate, setLoadingOfTemplate] = useState<TemplateModel | null>(null);
  const [loadingOfProject, setLoadingOfProject] = useState<ProjectModel | null>(null);
  const [loadingOfFunction, setLoadingOfFunction] = useState<FunctionModel | null>(null);
  const [apiStatusOfTemplates, setApiStatusOfTemplates] = useState<ApiStatuses>(ApiStatuses.Idle);
  const [apiStatusOfProjects, setApiStatusOfProjects] = useState<ApiStatuses>(ApiStatuses.Idle);
  const [apiStatusOfFunctions, setApiStatusOfFunctions] = useState<ApiStatuses>(ApiStatuses.Idle);

  const [viewOfTemplates, viewOfTemplatesApi] = useSpring(() => ({}));
  const [viewOfMyProjects, viewOfMyProjectsApi] = useSpring(() => ({}));
  const [viewOfMyFunctions, viewOfMyFunctionsApi] = useSpring(() => ({}));
  const [isFirstPreview, setIsFirstPreview] = useState<boolean>(true);
  const [screenLoader, setScreenLoader] = useState<boolean>(true);

  const isMyProjectsLoading = useMemo(() => {
    return apiStatusOfProjects === ApiStatuses.Idle || apiStatusOfProjects === ApiStatuses.Pending;
  }, [apiStatusOfProjects]);

  const quickStart = useSignal<QuickStartModel | null>(null);

  const {
    gql: {
      query: { relationSet, objectSet },
      mutation: { shareStudioFunction, shareStudioProject, deleteRelations },
    },
  } = useObjectRelationGqlRequest();

  const handleVideoModalOpenChange = useCallback(
    (isOpen: boolean) => {
      setVideoModalState({
        ...videoModalState,
        isOpen,
      });
    },
    [videoModalState]
  );

  const [projectPage, setProjectPage] = useState<number>(1);

  const loadProjects = useCallback(async () => {
    try {
      setApiStatusOfProjects(ApiStatuses.Pending);
      let newStateProjects: ProjectModel[] = [];
      let newProjectPage = 1;
      while (true) {
        const newProjects: ProjectModel[] = await relationSet(
          {
            name: "studio_project",
          },
          {
            page: newProjectPage,
            size: PROJECT_LOAD_SIZE,
          }
        );
        if (newProjectPage === 1) {
          setApiStatusOfProjects(ApiStatuses.Fulfilled);
        }
        if (newProjects.length === 0) {
          break;
        }
        newStateProjects = uniqBy([...newStateProjects, ...newProjects], "id");
        newProjectPage++;
        setProjectPage(newProjectPage);
        setMyProjects(newStateProjects);
      }
    } catch (error) {
      setApiStatusOfProjects(ApiStatuses.Rejected);
      notify({
        type: "error",
        message: "Notification",
        description: "Something went wrong",
      });
    }
  }, [relationSet]);

  const loadTemplates = useCallback(async () => {
    try {
      setApiStatusOfTemplates(ApiStatuses.Pending);
      const brainClient: any = getIt(FotClient);
      const response = await brainClient.webConfigApi.fetchWebConfig();
      const newTemplates: TemplateModel[] = response.studios.templates;
      setMyTemplates(newTemplates);
      quickStart.value = response.studios.quickstart;
      // Anton: set tutorials from the server but without project_id
      const newTutorials: TutorialModel[] = response.studios.example_videos;
      setMyTutorials(newTutorials);
      setApiStatusOfTemplates(ApiStatuses.Fulfilled);
    } catch (e) {
      setApiStatusOfTemplates(ApiStatuses.Rejected);
      notify({
        type: "error",
        message: "Notification",
        description: "Something went wrong",
      });
    }
  }, []);

  const load = useCallback(() => {
    loadTemplates();
    loadProjects();
  }, [loadProjects, loadTemplates]);

  useEffect(() => {
    load();
  }, [load]);

  ///////////////// OLD

  const showModal = useModal();

  const { handleWaitingTodo } = useWaitingTodo("editor.me.objectId", () => addNewProject());

  const setLoadingState = useCallback(
    (val: any) => {
      dispatch(studioActions.setLoadingState(val));
    },
    [dispatch]
  );
  const imageGenSelectOptions = useSelector((state: any) => state.fot.imageGenSelectOptions);
  const setSelectedTemplate = useCallback(
    (val: any) => {
      dispatch(studioActions.setSelectedTemplate(val));
    },
    [dispatch]
  );
  const showImagicaTutoriralLoading = useSelector((state: any) => state.editor.showImagicaTutoriralLoading);
  const setShowTooltip = useCallback(
    (val: any) => {
      dispatch(editorActions.setShowTooltip(val));
    },
    [dispatch]
  );
  const setEnableTooltipWhatTodo = useCallback(
    (val: any) => {
      dispatch(editorActions.setEnableTooltipWhatTodo(val));
    },
    [dispatch]
  );

  const setImageGenSelectOptions = useCallback(
    (val: any) => {
      dispatch(fotActions.setImageGenSelectOptions(val));
    },
    [dispatch]
  );
  const setFetching = useCallback(
    (val: any) => {
      dispatch(fotActions.setFetching(val));
    },
    [dispatch]
  );
  // const setReviseCustomCode = (val) => { dispatch(editorActions.setReviseCustomCode(val)) };
  const setCreateJSFuncData = useCallback(
    (val: any) => {
      dispatch(editorActions.setCreateJSFuncData(val));
    },
    [dispatch]
  );
  const setCreateAPIFuncData = useCallback(
    (val: any) => {
      dispatch(editorActions.setCreateAPIFuncData(val));
    },
    [dispatch]
  );

  const nextPageFlag = useRef("");
  const selectedExistingProject = useRef({});

  const [formatTemplates, setFormatTemplates] = useState<any>([]);
  const [existingProjectSearchTerm, setExistingProjectSearchTerm] = useState({
    value: "",
    label: "",
  });

  const setEditorIdArr = useCallback(
    (val: any) => {
      dispatch(fotActions.setEditorIdArr(val));
    },
    [dispatch]
  );
  const setCheckEdgeArr = useCallback(
    (val: any) => {
      dispatch(fotActions.setCheckEdgeArr(val));
    },
    [dispatch]
  );
  const setCheckNodeArr = useCallback(
    (val: any) => {
      dispatch(fotActions.setCheckNodeArr(val));
    },
    [dispatch]
  );

  const setStudioProjectName = useCallback(
    (val: any) => {
      dispatch(fotActions.setStudioProjectName(val));
    },
    [dispatch]
  );

  const adpotSelectedExistingProject = useCallback(() => {
    if (typeof loadFromExistingTemplateV2 === "function") {
      try {
        setSelectedTemplate(selectedExistingProject.current || {});
        loadFromExistingTemplateV2(selectedExistingProject.current);
      } catch (error: any) {
        console.error(error);
        notify({
          type: "error",
          message: "Notification",
          description: error.message,
        });
        return;
      }
    }
    setSelectedTemplate(selectedExistingProject.current || {});
  }, [setSelectedTemplate, loadFromExistingTemplateV2]);

  const getTemplateByName = useCallback(
    async (param: any): Promise<void | never> => {
      try {
        setFetching(true);
        const res = await objectSet({ ...param });
        if (func.isEmpty(res?.[0]?.attributes)) {
          // eslint-disable-next-line no-throw-literal
          throw "Get template failed";
        }

        // 点击已有project时转换v2数据到v3
        let attributesV2 = res[0].attributesV2;
        if (func.isEmpty(attributesV2.v3)) {
          attributesV2 = HomeUsePluginUtil.handleV2TransformV3Data({
            feature_tags,
            attributesV2,
            nodeIndexRef,
            edgeIndexRef,
            newEdgeDataRef: newEdgeDataRef,
            newLineDataRef: newLineDataRef,
          });
        }

        selectedExistingProject.current = {
          id: res[0].id,
          name: res[0].attributesV2.template_name,
          uuid: res[0].uuid,
          ...attributesV2,
        };
      } catch (error: any) {
        notify({
          type: "error",
          message: "Notification",
          description: error?.message || "Get template failed",
        });
        selectedExistingProject.current = {};
      } finally {
        setFetching(false);
      }
    },
    [edgeIndexRef, feature_tags, newEdgeDataRef, newLineDataRef, nodeIndexRef, objectSet, setFetching]
  );

  const getAppropriateParam = useCallback((value: any) => {
    const paramType = {
      attrIndexer: {
        key: "attrIndexer",
        value: value.attrIndexer,
      },
      uuid: {
        key: "uuid",
        value: value.uuid,
      },
      id: {
        key: "id",
        value: value.id,
      },
    };
    const param = {};
    Object.keys(paramType).some((x: any) => {
      if (!func.isEmpty(value[x])) {
        /** @ts-ignore */
        param[paramType[x].key] = paramType[x].value;
        return true;
      }
      return false;
    });
    return param;
  }, []);

  /**
   * 打开项目
   * @param {import('./types').FormatTemplateType} value
   */
  const openProject = useCallback(
    async (value: any) => {
      // 清空上一次的 previewApp 数据
      clearPreviewApp();
      // 清空上个项目显示数据
      emptyNodes();
      setEnableTooltipWhatTodo(false);
      // 进入已有项目显示 cot 图标
      setShowCot(false);
      setExistingProjectSearchTerm({
        value: value.value,
        label: value.label,
      });
      const param = getAppropriateParam(value);
      await getTemplateByName(param);
      adpotSelectedExistingProject();
      navigate(`/editor/${value.attrIndexer || value.uuid || value.id}`);
      setStudioProjectName(existingProjectSearchTerm.label);
      // 重置股票购买数据
      setEditorIdArr([]);
      setCheckEdgeArr([]);
      setCheckNodeArr([]);

      logEvent("open_project");
    },
    [
      getAppropriateParam,
      adpotSelectedExistingProject,
      existingProjectSearchTerm.label,
      getTemplateByName,
      navigate,
      setCheckEdgeArr,
      setCheckNodeArr,
      setEditorIdArr,
      setEnableTooltipWhatTodo,
      setStudioProjectName,
      emptyNodes,
      setShowCot,
    ]
  );

  const handleSelectedExistingTemplateChange = useCallback(
    async (value: any) => {
      // 加载中 禁止点击多个
      const isLoading = formatTemplates.some((x: any) => x.loading);
      if (isLoading) return;
      try {
        setFormatTemplates((prevList: any) => {
          return prevList.map((x: any) => {
            if (x.id === value.id) {
              return {
                ...x,
                loading: true,
              };
            }
            return x;
          });
        });
        await openProject(value);
      } catch (error) {
      } finally {
        setShowNavPage(false);
        setFormatTemplates((prevList: any) => {
          return prevList.map((x: any) => {
            if (x.id === value.id) {
              return {
                ...x,
                loading: false,
              };
            }
            return x;
          });
        });
      }
    },
    [formatTemplates, openProject, setShowNavPage]
  );

  const handleClickDelete = useCallback(
    (type: any, id: any, name: any, object: any = {}) => {
      return new Promise<boolean>(resolve => {
        showModal({
          width: 520,
          title: "Confirm your action",
          subTitle: `Do you want to delete the ${type} named "${name}"? This action cannot be undone.`,
          buttons: ["Cancel", "Delete"],
          danger: true,
          shouldExecuteOkOnEnter: true,
          onOk: async ({ setLoading, close }) => {
            let relationId = id;

            // For the copied functions or objects, they don't have relation id currently.
            if (isNil(id)) {
              const relationResponse = await relationSet(undefined, undefined, {
                destId: object.id,
              });
              relationId = relationResponse?.[0]?.relationId;
            }

            if (isNil(relationId)) {
              close();
              return notify({
                type: "error",
                message: "Notification",
                description: "No relation id found, delete failed",
              });
            }

            if (type === "project") {
              setFormatTemplates((prevList: any) => {
                return prevList.map((x: any) => {
                  if (x.relationId === relationId) {
                    return {
                      ...x,
                      loading: true,
                    };
                  }
                  return x;
                });
              });
            }
            setLoading(true);
            await deleteRelations(relationId, "", true);
            if (type === "project") {
              setFormatTemplates((prevList: any) => {
                return prevList
                  .map((x: any) => {
                    if (x.relationId === id) {
                      return {
                        ...x,
                        loading: false,
                      };
                    }
                    return x;
                  })
                  .filter((x: any) => x.relationId !== id);
              });
              setLoading(false);
              close();
            }
            if (type === "function") {
              getIt(PersonalFunctionStore).clean();
              setTimeout(async () => {
                handleUserSavedFunctions();
              }, 200);
              setLoading(false);
              close();
              logEvent("delete_function_confirmed", object);
            }
            resolve(true);
          },
          onCancel: () => {
            resolve(false);
          },
        });
      });
    },
    [deleteRelations, relationSet, handleUserSavedFunctions, showModal]
  );

  const setCardLoading = (id: any, bool: any) => {
    setFormatTemplates((prevList: any) => {
      return prevList.map((x: any) => {
        if (x.id === id) {
          return {
            ...x,
            loading: bool,
          };
        }
        return x;
      });
    });
  };

  const handleClickDuplicate = useCallback(
    async (type: "project" | "function" = "project", object: any) => {
      const isLoading = formatTemplates.some((x: any) => x.loading);
      if (isLoading) return;
      try {
        setCardLoading(object.id, true);
        const functionObj = {
          project: "shareStudioProject",
          function: "shareStudioFunction",
        };
        let method;
        if (functionObj[type] === "shareStudioProject") {
          method = shareStudioProject;
        } else if (functionObj[type] === "shareStudioFunction") {
          method = shareStudioFunction;
        } else {
          throw Error();
        }
        const res = await method(object.id, userMe.id, "", true);
        const formatObject = {
          id: res.id,
          label: res.attributesV2.name,
          value: res.attributesV2.name,
          loading: false,
        };
        if (type === "project") {
          setFormatTemplates((prevList: any) => {
            const index = findIndex(prevList, (item: any) => item.id === object.id);
            prevList.splice(index + 1, 0, { ...formatObject });
            return prevList;
          });
        } else {
          const newImageGenSelectOptions = [...imageGenSelectOptions];
          const index = findIndex(newImageGenSelectOptions, item => item.id === object.id);
          const newOptions = {
            ...newImageGenSelectOptions[index],
            id: res.id,
            relationId: undefined,
            label: res.attributesV2.name,
            value: res.attributesV2.name,
            name: res.attributesV2.name,
          };
          newImageGenSelectOptions.splice(index + 1, 0, newOptions);
          setImageGenSelectOptions(newImageGenSelectOptions);
          pushFunc({
            ...newOptions,
            edgeArr: JSON.parse(newOptions.edgeArr),
            nodeArr: JSON.parse(newOptions.nodeArr),
          });
        }
        return res;
      } catch (error: any) {
        console.error(error);
        throw Error();
      } finally {
        setCardLoading(object.id, false);
      }
    },
    [
      shareStudioFunction,
      shareStudioProject,
      formatTemplates,
      imageGenSelectOptions,
      pushFunc,
      setImageGenSelectOptions,
      userMe.id,
    ]
  );

  const clickModifyFunction = useCallback(
    (obj: any) => {
      // use obj.id to determine hardcoded function , and use obj.editable to determine global function
      // const valueArr = ['protein', 'imageGen', 'stockInfo', 'midjourney', 'video', 'jdShopping', 'amazonShopping']
      if (!obj.id || !obj.editable) return;
      setEnableTooltipWhatTodo(false);
      switch (obj.type) {
        case "CustomCode":
          // props.setMyModificationData(obj)
          // setReviseCustomCode(true)
          setCreateJSFuncData({
            open: true,
            edgeId: "",
            sourceNodeId: "",
            targetNodeId: "",
            state: "modify",
            select: obj,
            parameter: {
              name: obj.value,
              description: obj.description,
            },
          });
          break;
        case "customApi":
          setCreateAPIFuncData({
            open: true,
            edgeId: "",
            sourceNodeId: "",
            targetNodeId: "",
            state: "modify",
            select: obj,
            parameter: {
              name: obj.value,
              description: obj.description,
            },
          });
          break;
        default:
          setShowNavPage(false);
          setShowMyModification(true);
          setMyModificationData(obj);
          // setCreateJSFuncData({
          //   open: true,
          //   edgeId: '',
          //   sourceNodeId: '',
          //   targetNodeId: '',
          //   select: obj
          // })
          break;
      }
    },
    [
      setCreateAPIFuncData,
      setCreateJSFuncData,
      setEnableTooltipWhatTodo,
      setMyModificationData,
      setShowMyModification,
      setShowNavPage,
    ]
  );

  const handleClickAddNewProject = useCallback(() => {
    if (showImagicaTutoriralLoading) return;
    homeStore.setIsClickAddNewProject(true);
    setLoadingState({
      promptSaveBtn: true,
      promptNewBtn: true,
      promptCard: true,
    });
    setSelectedTemplate({});
    setShowTooltip("");
    clearPreviewApp();

    handleWaitingTodo();
  }, [handleWaitingTodo, setLoadingState, setSelectedTemplate, setShowTooltip, showImagicaTutoriralLoading]);

  /**
   * TODO: 将 openProjectByShareProject 和 entryCanvas 整合
   * @param {import('./types').FormatTemplateType} value
   */
  const openProjectByShareProject = async (value: any) => {
    await openProject(value);
    // target:handleSelectedExistingTemplateChange -> finally
    setShowNavPage(false);
  };

  const { onShareProject } = useProjectTemplate({
    onShareProject: openProjectByShareProject,
  });

  const handleProjectTemplateClick = useCallback(
    async (item: any) => {
      try {
        await onShareProject(item);
      } catch (error) {
        console.error("handleProjectTemplateClick", error);
      }
    },
    [onShareProject]
  );

  /////////////// NEW

  const handleEducationPreviewClick = useCallback(() => {
    setIsFirstPreview(false);
    const template = myTemplates[1];
    handleProjectTemplateClick(template);
  }, [myTemplates, handleProjectTemplateClick]);

  const handleExplorePreviewClick = useCallback(() => {
    setIsFirstPreview(false);
    setContent(Contents.Templates);
    setSidebarItem(SidebarItems.Templates);
  }, []);

  useEffect(() => {
    setApiStatusOfFunctions(ApiStatuses.Pending);
    const newMyFunctions = imageGenSelectOptions?.filter((item: any) => item.editable);
    setMyFunctions(newMyFunctions);
    setApiStatusOfFunctions(ApiStatuses.Fulfilled);
  }, [imageGenSelectOptions]);

  const handleFunctionClick = useCallback(
    async (func: FunctionModel) => {
      logEvent("open_function", {
        function_static_id: func.attrIndexer ?? func.uuid ?? func.id,
        function_name: func.label,
      });
      setLoadingOfFunction(func);
      await delay(1000);
      clickModifyFunction(func);
      setLoadingOfFunction(null);
    },
    [clickModifyFunction]
  );

  const handleFunctionNameChange = useCallback((name: string, func: FunctionModel) => {}, []);

  const handleFunctionDropdownClick = useCallback(
    async (args: FunctionDropdownItemArgs) => {
      if (args.type === FunctionDropdownItems.Duplicate) {
        const copyFunc = await handleClickDuplicate("function", args.func);
        logEvent("duplicate_Function", {
          source_id: args.func.attrIndexer ?? args.func.uuid,
          destination_id: copyFunc.uuid,
        });
        func.messageUtil("Successfully duplicated function", "success");
      }
      if (args.type === FunctionDropdownItems.Delete) {
        logEvent("delete_function_confirmed");
        const func: any = args.func;
        const isOk = await handleClickDelete("function", func.relationId, func.label, func);
        if (isOk) {
          func.messageUtil("The function has been deleted successfully", "success");
          handleUserSavedFunctions();
        }
      }
    },
    [handleClickDuplicate, handleClickDelete, handleUserSavedFunctions]
  );

  const handleProjectClick = useCallback(
    async (project: ProjectModel) => {
      setLoadingOfProject(project);
      await handleSelectedExistingTemplateChange(project);
      setLoadingOfProject(null);
    },
    [handleSelectedExistingTemplateChange]
  );

  const handleProjectNameChange = useCallback((name: string, project: ProjectModel) => {}, []);

  const handleProjectDropdownClick = useCallback(
    async (args: ProjectDropdownItemArgs) => {
      if (args.type === ProjectDropdownItems.Duplicate) {
        const destinationProject = await handleClickDuplicate("project", args.project);
        logEvent("duplicate_Function", {
          source_id: args.project.attrIndexer ?? args.project.uuid,
          destination_id: destinationProject.uuid,
        });
        func.messageUtil("Successfully duplicated project", "success");
        await loadProjects();
      }
      if (args.type === ProjectDropdownItems.Delete) {
        const project: any = args.project;
        const isOk = await handleClickDelete(
          "project",
          project.relationId,
          project.attributesV2?.name || "Untitled",
          project
        );
        logEvent("delete_project_confirmed", args.project);
        if (isOk) {
          func.messageUtil("The project has been deleted successfully", "success");
          await loadProjects();
        }
      }
    },
    [handleClickDuplicate, handleClickDelete, loadProjects]
  );

  const handleTemplateAddClick = useCallback(
    async (template: TemplateModel) => {
      setLoadingOfTemplate(template);
      await handleProjectTemplateClick(template);
      setLoadingOfTemplate(null);
    },
    [handleProjectTemplateClick]
  );

  const handleTutorialClick = useCallback(
    (tutorial: TutorialModel) => {
      logEvent("watch_tutorial", { tutorial: tutorial.name });
      setVideoModalState({
        ...videoModalState,
        isOpen: true,
        videoUrl: tutorial.video_url,
        videoName: "tutorial",
      });
    },
    [videoModalState]
  );

  const playQuickStartVideo = useCallback(() => {
    logEvent("quickstart_video");
    setVideoModalState({
      ...videoModalState,
      isOpen: true,
      videoName: "quickstart",
      videoUrl: quickStart.value?.video ?? getAssetsVideo("quickStart.mp4"),
    });
  }, [videoModalState, quickStart.value?.video]);

  const getQuickStartTemplate = useCallback(async () => {
    const env = process.env.REACT_APP_ENVIRONMENT ?? "development";
    const defaultProjectId = env === "production" ? 1392261 : 169494;
    await handleProjectTemplateClick({
      project_id: quickStart.value?.project_id ?? defaultProjectId,
      title: quickStart.value?.project_name ?? "Cooking Plan",
      description: "",
    });
  }, [quickStart.value]);

  const handleTemplateClick = useCallback(
    async (template: TemplateModel) => {
      await handleProjectTemplateClick(template);
    },
    [handleProjectTemplateClick]
  );

  const handleSidebarItemChange = useCallback(
    (newSidebarItem: SidebarItems) => {
      setIsFirstPreview(false);
      switch (newSidebarItem) {
        case SidebarItems.CreateNewProject:
          handleClickAddNewProject();
          return;
        case SidebarItems.Templates:
          // clickLogEvent('home sidebar templates');
          setSidebarItem(SidebarItems.Templates);
          setContent(Contents.Templates);
          break;
        case SidebarItems.MyProjects:
          // clickLogEvent('home sidebar projects');
          setSidebarItem(SidebarItems.MyProjects);
          setContent(Contents.Projects);
          break;
        case SidebarItems.MyFunctions:
          // clickLogEvent('home sidebar functions');
          setSidebarItem(SidebarItems.MyFunctions);
          setContent(Contents.Functions);
          break;
      }
      setSidebarItem(newSidebarItem);
    },
    [handleClickAddNewProject]
  );

  const nextProjects = useCallback(async () => {
    try {
      const newPage = projectPage + 1;
      setPage(newPage);
      const newProjects: ProjectModel[] = await relationSet(
        {
          name: "studio_project",
        },
        {
          page: projectPage,
          size: 20,
        }
      );
      const newStateProjects = uniqBy([...myProjects, ...newProjects], "id");
      setMyProjects(newStateProjects);
    } catch (error) {}
  }, [myProjects, projectPage, relationSet]);

  const [templatesStyle, setTemplatesStyle] = useState<CSSProperties>({
    position: "absolute",
    top: "200px",
  });
  const [projectsStyle, setProjectsStyle] = useState<CSSProperties>({
    position: "absolute",
    top: "200px",
  });
  const [functionsStyle, setFunctionsStyle] = useState<CSSProperties>({
    position: "absolute",
    top: "200px",
  });

  const setAnimationCompletionStyles = (content: Contents) => {
    const showStyle: CSSProperties = { display: "flex", position: "relative", zIndex: 100 };
    const hideStyle: CSSProperties = { display: "none", top: "200px" };
    setTemplatesStyle(content === Contents.Templates ? showStyle : hideStyle);
    setProjectsStyle(content === Contents.Projects ? showStyle : hideStyle);
    setFunctionsStyle(content === Contents.Functions ? showStyle : hideStyle);
  };

  useEffect(() => {
    const main = async () => {
      if (content === Contents.Templates) {
        setTemplatesStyle({ display: "flex", position: "relative", zIndex: 100 });
        await Promise.all(
          viewOfTemplatesApi.start({
            config: { duration: 500 },
            from: {
              opacity: 0,
              top: "200px",
            },
            to: {
              opacity: 1,
              top: "0px",
            },
          })
        );
        setAnimationCompletionStyles(Contents.Templates);
      } else {
        setTemplatesStyle({ position: "absolute", zIndex: 50 });
        await Promise.all(
          viewOfTemplatesApi.start({
            config: { duration: 250 },
            to: {
              opacity: 0,
            },
          })
        );
        setTemplatesStyle({ display: "none", top: "200px" });
      }
    };
    main();
  }, [content, viewOfMyFunctionsApi, viewOfMyProjectsApi, viewOfTemplatesApi]);

  useEffect(() => {
    const main = async () => {
      if (content === Contents.Projects) {
        setProjectsStyle({ display: "flex", position: "relative", zIndex: 100 });
        await Promise.all(
          viewOfMyProjectsApi.start({
            config: { duration: 500 },
            from: {
              opacity: 0,
              top: "200px",
            },
            to: {
              opacity: 1,
              top: "0px",
            },
          })
        );
        setAnimationCompletionStyles(Contents.Projects);
      } else {
        setProjectsStyle({ position: "absolute", zIndex: 50 });
        await Promise.all(
          viewOfMyProjectsApi.start({
            config: { duration: 250 },
            to: {
              opacity: 0,
            },
          })
        );
        setProjectsStyle({ display: "none", top: "200px" });
      }
    };
    main();
  }, [content, viewOfMyFunctionsApi, viewOfMyProjectsApi, viewOfTemplatesApi]);

  useEffect(() => {
    const main = async () => {
      if (content === Contents.Functions) {
        setFunctionsStyle({ display: "flex", position: "relative", zIndex: 100 });
        await Promise.all(
          viewOfMyFunctionsApi.start({
            config: { duration: 500 },
            from: {
              opacity: 0,
              top: "200px",
            },
            to: {
              opacity: 1,
              top: "0px",
            },
          })
        );
        setAnimationCompletionStyles(Contents.Functions);
      } else {
        setFunctionsStyle({ position: "absolute", zIndex: 50 });
        await Promise.all(
          viewOfMyFunctionsApi.start({
            config: { duration: 250 },
            to: {
              opacity: 0,
            },
          })
        );
        setFunctionsStyle({ display: "none", top: "200px" });
      }
    };
    main();
  }, [content, viewOfMyFunctionsApi, viewOfMyProjectsApi, viewOfTemplatesApi]);

  const isTemplateLoading = useCallback(
    (template: TemplateModel) => !!loadingOfTemplate && loadingOfTemplate.project_id === template.project_id,
    [loadingOfTemplate]
  );

  const isProjectLoading = useCallback(
    (project: ProjectModel) => !!loadingOfProject && loadingOfProject.id === project.id,
    [loadingOfProject]
  );

  const isFunctionLoading = useCallback(
    (func: FunctionModel) => !!loadingOfFunction && loadingOfFunction.id === func.id,
    [loadingOfFunction]
  );

  useEffect(() => {
    if (!isMyProjectsLoading) {
      if (myProjects?.length > 0) {
        setSidebarItem(SidebarItems.MyProjects);
        setContent(Contents.Projects);
      } else {
        setSidebarItem(SidebarItems.Templates);
        setContent(Contents.Templates);
      }
      setTimeout(() => {
        setScreenLoader(false);
      }, 500);
    }
  }, [isMyProjectsLoading]);

  return (
    <main className={style.main}>
      <div className={style.main__sidebar}>
        <Sidebar sidebarItem={sidebarItem} onSidebarItemChange={handleSidebarItemChange} />
      </div>
      <div className={style.main__content}>
        <div className={style.gridHomeRgtBox}>
          <div className={style.gridHeaderLft}>
            <Carousel
              templates={myTemplates}
              tutorials={myTutorials}
              onTemplateClick={handleTemplateClick}
              onTutorialClick={handleTutorialClick}
            />
          </div>
          <div className={style.gridHeaderRgt}>
            <PreviewQuickStart
              isShown={content === Contents.Templates}
              isFirst={isFirstPreview}
              onVideoPlay={playQuickStartVideo}
              onGetTemplate={getQuickStartTemplate}
            />
            <PreviewExplorer
              isShown={content !== Contents.Templates}
              isFirst={isFirstPreview}
              onClick={handleExplorePreviewClick}
            />
          </div>
          <div className={style.gridMainContentBox}>
            {screenLoader ? (
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Loader full={true} />
              </div>
            ) : (
              <div className={style.content__view}>
                <animated.div
                  style={{
                    ...templatesStyle,
                    ...viewOfTemplates,
                  }}
                  className={cls(style.view)}
                >
                  <div className={style.view__title}>Templates</div>
                  <div className={style.view__content}>
                    <ApiProgress status={apiStatusOfTemplates} full>
                      {myTemplates.map((item, index) => (
                        <Template
                          key={index}
                          template={item}
                          loading={isTemplateLoading(item)}
                          onClick={handleTemplateAddClick}
                          onAddClick={handleTemplateAddClick}
                        />
                      ))}
                    </ApiProgress>
                  </div>
                </animated.div>

                <animated.div
                  className={cls(style.view)}
                  style={{
                    ...projectsStyle,
                    ...viewOfMyProjects,
                  }}
                >
                  <div className={style.view__title}>My Projects</div>
                  <InfiniteScroll
                    className={style.view__content}
                    dataLength={myProjects.length}
                    loader={null}
                    hasMore={true}
                    next={nextProjects}
                    scrollableTarget="homeContainer"
                  >
                    <ApiProgress status={apiStatusOfProjects} full>
                      {myProjects.map(item => (
                        <Project
                          key={item.id}
                          project={item}
                          loading={isProjectLoading(item)}
                          onClick={handleProjectClick}
                          onNameChange={handleProjectNameChange}
                          onDropdownClick={handleProjectDropdownClick}
                        />
                      ))}
                    </ApiProgress>
                  </InfiniteScroll>
                </animated.div>

                <animated.div
                  className={cls(style.view)}
                  style={{
                    ...functionsStyle,
                    ...viewOfMyFunctions,
                  }}
                >
                  <div className={style.view__title}>My Functions</div>
                  <div className={style.view__content}>
                    <ApiProgress status={apiStatusOfFunctions} full>
                      {myFunctions.map(item => (
                        <Function
                          key={item.id}
                          func={item}
                          loading={isFunctionLoading(item)}
                          onClick={handleFunctionClick}
                          onNameChange={handleFunctionNameChange}
                          onDropdownClick={handleFunctionDropdownClick}
                        />
                      ))}
                    </ApiProgress>
                  </div>
                </animated.div>
              </div>
            )}
          </div>
        </div>
        {/* <div className={style.content}>
          <div className={style.content__header}>
            <div className={style.contentHeader}>
              <div className={style.contentHeader__slider}>
                <Carousel
                  templates={myTemplates}
                  tutorials={myTutorials}
                  onTemplateClick={handleTemplateClick}
                  onTutorialClick={handleTutorialClick}
                />
              </div>
              <div className={style.contentHeader__preview}>
                <PreviewQuickStart
                  isShown={content === Contents.Templates}
                  isFirst={isFirstPreview}
                  onVideoPlay={playQuickStartVideo}
                  onGetTemplate={getQuickStartTemplate}
                />
                <PreviewExplorer
                  isShown={content !== Contents.Templates}
                  isFirst={isFirstPreview}
                  onClick={handleExplorePreviewClick}
                />
              </div>
            </div>
          </div>
          {screenLoader ? (
            <div
              style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}
            >
              <Loader full={true} />
            </div>
          ) : (
            <div className={style.content__view}>
              <animated.div
                style={{
                  ...templatesStyle,
                  ...viewOfTemplates,
                }}
                className={cls(style.view)}
              >
                <div className={style.view__title}>Templates</div>
                <div className={style.view__content}>
                  <ApiProgress status={apiStatusOfTemplates} full>
                    {myTemplates.map((item, index) => (
                      <Template
                        key={index}
                        template={item}
                        loading={isTemplateLoading(item)}
                        onClick={handleTemplateAddClick}
                        onAddClick={handleTemplateAddClick}
                      />
                    ))}
                  </ApiProgress>
                </div>
              </animated.div>

              <animated.div
                className={cls(style.view)}
                style={{
                  ...projectsStyle,
                  ...viewOfMyProjects,
                }}
              >
                <div className={style.view__title}>My Projects</div>
                <InfiniteScroll
                  className={style.view__content}
                  dataLength={myProjects.length}
                  loader={null}
                  hasMore={true}
                  next={nextProjects}
                  scrollableTarget="homeContainer"
                >
                  <ApiProgress status={apiStatusOfProjects} full>
                    {myProjects.map(item => (
                      <Project
                        key={item.id}
                        project={item}
                        loading={isProjectLoading(item)}
                        onClick={handleProjectClick}
                        onNameChange={handleProjectNameChange}
                        onDropdownClick={handleProjectDropdownClick}
                      />
                    ))}
                  </ApiProgress>
                </InfiniteScroll>
              </animated.div>

              <animated.div
                className={cls(style.view)}
                style={{
                  ...functionsStyle,
                  ...viewOfMyFunctions,
                }}
              >
                <div className={style.view__title}>My Functions</div>
                <div className={style.view__content}>
                  <ApiProgress status={apiStatusOfFunctions} full>
                    {myFunctions.map(item => (
                      <Function
                        key={item.id}
                        func={item}
                        loading={isFunctionLoading(item)}
                        onClick={handleFunctionClick}
                        onNameChange={handleFunctionNameChange}
                        onDropdownClick={handleFunctionDropdownClick}
                      />
                    ))}
                  </ApiProgress>
                </div>
              </animated.div>
            </div>
          )}
        </div> */}
      </div>
      <VideoModal
        isOpen={videoModalState.isOpen}
        videoUrl={videoModalState.videoUrl}
        videoName={videoModalState.videoName}
        onOpenChange={handleVideoModalOpenChange}
      />
      <Help />
    </main>
  );
};

export default Home;
